// /components/reports/components/MockOptions.js
import React, { useState, useEffect } from 'react';
import { Form, Stack } from 'react-bootstrap';
import { ErrorMsg } from '../../../utils/Toast'; // Adjust path as needed

import { getMocksPerClass } from '../../../utils/mock'; // Adjust path as needed

function MockOptions({ selectedClass, selectedMock, onChange }) {
  const [mocks, setMocks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!selectedClass) {
      setMocks([]);
      return;
    }
    const fetchMocks = async () => {
      setIsLoading(true);
      try {
        const res = await getMocksPerClass(selectedClass);
        setMocks(res.data?.mocks || []);
      } catch (e) {
        ErrorMsg('Failed to fetch mocks');
      } finally {
        setIsLoading(false);
      }
    };
    fetchMocks();
  }, [selectedClass]);

  return (
    <Stack gap={3} className="p-2 border rounded">
      <Form.Label>Mock Options</Form.Label>
      <Form.Group controlId="mockSelect">
        <Form.Label>Select Mock</Form.Label>
        <Form.Select
          name="selectedMock"
          value={selectedMock}
          onChange={onChange} // This is the simple change handler
        >
          <option value="">{isLoading ? 'Loading mocks...' : 'Choose...'}</option>
          {mocks.map((mock) => (
            <option key={mock._id} value={mock._id}>
              {mock.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Stack>
  );
}

export default MockOptions;